import '../styles/globals.css'
import '../styles/theme-pink.css'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { startBehaviorTracking, stopContent, watchSections } from '/src/lib/behavior'
import Script from "next/script";
import Layout from '/src/components/Layout'
import Navbar from '/src/components/Navbar.js'
import dynamic from 'next/dynamic'
import { Nunito, Fredoka } from 'next/font/google'

// Fonts are self-hosted and preloaded by next/font, with size-matched fallbacks, so text doesn't
// jump when they load (layout shift). CSS uses them through --font-nunito / --font-fredoka.
const nunito = Nunito({ subsets: ['latin'], display: 'swap' })
const fredoka = Fredoka({ subsets: ['latin'], display: 'swap' })

// Seasonal decorations: browser-only, switch themselves on/off by date (see src/fx/Halloween_fx.js)
const Halloween_fx = dynamic(() => import('/src/fx/Halloween_fx'), { ssr: false })


function MyApp({ Component, pageProps }) {
  const router = useRouter()

  useEffect(() => {
    // No page_view is sent here: GA4 counts page changes itself (enhanced measurement), and sending one too counted each twice
    const handleRouteChange = () => {
      watchSections()
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    router.events.on('routeChangeStart', stopContent)
    const stopTracking = startBehaviorTracking()
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
      router.events.off('routeChangeStart', stopContent)
      stopTracking()
    }
  }, [router.events])

  return (
    <>
    
    {/* <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8631388926560357" crossorigin="anonymous"></script>  */}

    <style jsx global>{`
      :root {
        --font-nunito: ${nunito.style.fontFamily};
        --font-fredoka: ${fredoka.style.fontFamily};
      }
    `}</style>
    <Layout>
      <Navbar />
      <Component {...pageProps} />
    </Layout>
    {/* outside Layout so the props stay visible while the page fades during a page change */}
    <Halloween_fx />
    </>
  )
}

export default MyApp
